import React from "react";
import { CheckIn } from "../components";

export function CheckInContainer() {
  const digitalChekinObj = [
    {
      icon: "/images/icons/vector (5).png",
      arrowIcon: "/images/icons/Arrow 1 (1).png",
      title: "Visitor enter",
    },
    {
      icon: "/images/icons/vector (6).png",
      arrowIcon: "/images/icons/Arrow 1 (1).png",
      title: "Check in via iPad",
    },
    {
      icon: "/images/icons/vector (7).png",
      arrowIcon: "/images/icons/Arrow 1 (1).png",
      title: "Meets",
    },
    // { icon: "/images/icons/vector (8).png", title: "Check out via Central Dashboard" },
  ];
  return (
    <CheckIn>
      {/* <CheckIn.SubHeading>How it works</CheckIn.SubHeading> */}
      <CheckIn.Heading>How it works</CheckIn.Heading>
      <CheckIn.Line/>
      <CheckIn.Frame>
        {digitalChekinObj.map((item) => (
          <CheckIn.Pane>
          <CheckIn.InfoContainer>
              <CheckIn.Logo src={item.icon} />
             <CheckIn.LogoArrow src={item.arrowIcon} />
            </CheckIn.InfoContainer>
            <CheckIn.Text>{item.title}</CheckIn.Text>
          </CheckIn.Pane>
        ))}
        <CheckIn.Pane>
          <CheckIn.Logo src="/images/icons/vector (8).png" />
          <CheckIn.Text>Check out via Central Dashboard</CheckIn.Text>
        </CheckIn.Pane>
      </CheckIn.Frame>
    </CheckIn>
  );
}
